<template>
    <div class="product-recycle-bin">
        <el-form class="custom-form" ref="screenForm" :inline="true" :model="screenForm">
            <el-form-item label="开始日期" prop="startTime">
                <el-date-picker
                    v-model="screenForm.startTime"
                    type="date"
                    align="right"
                    placeholder="选择日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期" prop="endTime">
                <el-date-picker
                    v-model="screenForm.endTime"
                    type="date"
                    align="right"
                    placeholder="选择日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
            </el-form-item>
            <el-form-item prop="idTitleSku" class="custom-input">
                <el-input v-model="screenForm.idTitleSku" placeholder="请输入产品ID或父SKU"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getTableList">查询</el-button>
                <el-button type="primary" @click="onReset('screenForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="summary_pagenum">
            <div class="summary_query">
                符合查询条件的产品共
                <span>{{ productTotal }}</span>
                件
            </div>
            <!-- <el-pagination
                @size-change="handleSizeChange"
                :current-page="currentPage"
                :page-sizes="[20, 50, 100, 200]"
                layout="total, sizes"
                :total="productTotal"
            ></el-pagination>-->
        </div>
        <div class="summary_content">
            <div class="summary_batch">
                <div>已选择产品{{ checkedProductsList.length }}件</div>
                <el-divider direction="vertical"></el-divider>
                <el-button type="text" class="custom-btn" @click="productReduction">批量还原</el-button>
                <el-button type="text" class="custom-btn" @click="productDelete">批量删除</el-button>
            </div>
            <div class="summary_list">
                <!-- 头部-->

                <el-table
                    :data="tableList"
                    style="width: 100%"
                    v-loading="loading === 'table'"
                    element-loading-text="拼命加载中"
                    border
                    @selection-change="handleSelectionChange"
                    :header-cell-style="tableHeadStyle"
                    stripe
                >
                    <!-- :cell-style="tableContentStyle" -->
                    <el-table-column width="50" type="selection" align="center"></el-table-column>
                    <el-table-column width="200" label="产品ID" prop="productNumber" align="center"></el-table-column>
                    <el-table-column label="主图" width="140" align="center">
                        <template slot-scope="scope">
                            <el-popover trigger="hover" placement="right">
                                <img :src="scope.row.productImgUrl" class="prduct_img" alt />
                                <div class="scope_img" slot="reference">
                                    <img :src="scope.row.productImgUrl" alt />
                                </div>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column prop="title" label="标题"></el-table-column>
                    <el-table-column
                        width="240"
                        prop="sku"
                        label="父SKU"
                        show-overflow-tooltip
                        align="center"
                    ></el-table-column>
                    <el-table-column width="180" prop="productPrice" label="价格" align="center">
                        <template slot-scope="scope">
                            <div>{{ scope.row.productPrice }}</div>
                            <!-- + (scope.row.priceCurrency?`(${scope.row.priceCurrency})`:'') -->
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="sourceLink" label="来源" width="180"></el-table-column> -->

                    <el-table-column width="100" label="来源" align="center">
                        <!-- <template slot-scope="scope">
                            <template v-for="item in scope.row.sourceLinks">
                                <div :key="item">
                                    <el-link
                                        class="imgLink"
                                        :underline="false"
                                        :href="item"
                                        target="_blank"
                                    >{{item}}</el-link>
                                </div>
                            </template>
                        </template>-->

                        <template slot-scope="scope">
                            <template v-if="scope.row.sourceLinks && scope.row.sourceLinks.length">
                                <template v-for="(item, index) in scope.row.sourceLinks">
                                    <div :key="item">
                                        <el-link :href="item" target="_blank" type="primary">
                                            {{ "BUY" + (scope.row.sourceLinks.length > 1 ? index + 1 : "") }}
                                        </el-link>
                                    </div>
                                </template>
                            </template>
                            <template v-else>
                                <div>暂无</div>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="180" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" class="custom-btn" @click="productReduction(scope.row, 'single')">
                                还原
                            </el-button>
                            <el-button type="text" class="custom-btn" @click="productDelete(scope.row, 'single')">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="summary_pagenum_block">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[20, 50, 100, 200]"
                layout="total, sizes,prev, pager, next, jumper"
                :total="productTotal"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from "../../../api/api/api";

export default {
    data() {
        return {
            UserInfo: {},
            screenForm: {
                startTime: "",
                endTime: "",
                idTitleSku: "",
            },
            productTotal: 0,
            currentPage: 1,
            currentSize: 20,
            tableList: [],
            loading: "",
            tableHeadStyle: {
                textAlign: "center",
                background: "#f8f8f8",
                color: "#232323",
            },
            tableContentStyle: {
                textAlign: "center",
            },
            checkedProductsList: [],
        };
    },
    created() {
        this.UserInfo = JSON.parse(localStorage.getItem("role"));
        this.getTableList();
    },
    computed: {},
    methods: {
        getTableList() {
            this.loading = "table";
            const API = Baseurl + "productController/selectRecycleProducts";
            const paramsData = {
                page: this.currentPage,
                size: this.currentSize,
                staffId: this.UserInfo.rid, //this.input, //登录人id
                startTime: this.screenForm.startTime,
                endTime: this.screenForm.endTime,
                idTitleSku: this.screenForm.idTitleSku,
                companyId: this.UserInfo.company_id,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                this.loading = "";
                if (code === 200) {
                    const { total, list } = data;
                    this.productTotal = total;
                    this.tableList = list;
                }
            });
        },
        onReset(formName) {
            this.$refs[formName].resetFields();
        },
        handleSizeChange(val) {
            this.currentSize = val;
            this.currentPage = 1;
            this.getTableList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getTableList();
        },
        handleSelectionChange(event) {
            console.log(event);
            this.checkedProductsList = event.length ? event.map(item => item.productNumber) : [];
            // if (event.length) {
            //     this.checkedProductsList = event.map(
            //         item => item.productNumber
            //     );
            // } else {
            //     this.checkedProductsList = [];
            // }
        },
        productReduction(item, type = "many") {
            if (type === "single") {
                this.checkedProductsList = [];
                this.checkedProductsList.push(item.productNumber);
            } else if (!this.checkedProductsList.length) {
                this.$message.warning('请至少选中一件产品')
                return
            }
            const request = () => {
                const API = Baseurl + "productController/reductionByProductNumber";
                const paramsData = {
                    productNumbers: this.checkedProductsList,
                };
                ajaxPost(API, paramsData).then(res => {
                    const { code } = res.data;
                    if (code === 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        });
                        this.getTableList();
                    }
                });
            };
            const tips = type === "single" ? "此操作将还原该产品，是否继续？" : "此操作将还原选中的产品，是否继续？";
            this.$confirm(tips, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            })
                .then(() => {
                    request();
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消操作",
                    });
                });
        },
        productDelete(item, type = "many") {
            if (type === "single") {
                this.checkedProductsList = [];
                this.checkedProductsList.push(item.productNumber);
            } else if (!this.checkedProductsList.length) {
                this.$message.warning('请至少选中一件产品')
                return
            }
            const request = () => {
                const API = Baseurl + "productController/deleteByProductNumber";
                const paramsData = {
                    productNumbers: this.checkedProductsList,
                };
                ajaxPost(API, paramsData).then(res => {
                    const { code } = res.data;
                    if (code === 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        });
                        this.getTableList();
                    }
                });
            };
            const tips = type === "single" ? "此操作将删除该产品，是否继续？" : "此操作将删除选中的产品，是否继续？";
            this.$confirm(tips, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            })
                .then(() => {
                    request();
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消操作",
                    });
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.product-recycle-bin {
    padding-bottom: 72px;
    /deep/ .custom-form {
        .el-form-item {
            margin-bottom: 0;
        }
        .custom-input {
            .el-form-item__content {
                width: 350px;
            }
        }
    }

    .summary_pagenum {
        width: 100%;
        height: 32px;
        margin: 10px 0;
        overflow: hidden;
        background: #f5f5f5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .summary_query {
            width: 20%;
            padding: 0 10px;
            letter-spacing: 1px;
            color: #585858;
            span {
                color: #2c8dff;
            }
        }
    }
    .summary_content {
        width: 100%;
        border: 1px solid #eee;
        overflow: hidden;
        box-sizing: border-box;
        .summary_batch {
            display: flex;
            align-items: center;
            padding: 5px 10px;
            color: #409eff;
        }
    }
    .summary_list {
        .scope_img {
            width: 55px;
            height: 55px;
            margin: 0 auto;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .imgLink {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: block;
        }
    }
    /deep/ .custom-btn.el-button {
        padding: 12px 0;
    }
    .summary_pagenum_block {
        width: 1789px;
        padding: 20px;
        position: fixed;
        right: 0;
        bottom: 0;
        background: #fff;
        z-index: 999;
        .el-pagination {
            display: flex;
            justify-content: center;
        }
    }
}
.prduct_img {
    width: 500px;
    height: 500px;
}
</style>
